export const SIGNUP_PATH = '/signup';
export const LOGIN_PATH = '/signin';
export const ACCOUNT_SIGNUP_PATH = '/account_signup';

export function getCurrentRoutePath () {
  return window.location.pathname;
}

export function isPathSignup (path) {
  return path === SIGNUP_PATH
}

export function isPathLogin (path) {
  return path === LOGIN_PATH
}

export function isPathAccountSignup (path) {
  return path === ACCOUNT_SIGNUP_PATH
}

export function navigateTo (path, withParams = true) {
  window.location.href = path + (withParams ? window.location.search : "");
}


// WEBPACK FOOTER //
// ./app/javascript/util/route.js